/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Few_Cool_Bullock_AssureInputs */

const fr_few_cool_bullock_assure = /** @type {(inputs: Few_Cool_Bullock_AssureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun enregistrement trouvé`)
};

/**

* @param {Few_Cool_Bullock_AssureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const few_cool_bullock_assure = /** @type {((inputs?: Few_Cool_Bullock_AssureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Few_Cool_Bullock_AssureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_few_cool_bullock_assure(inputs)
});